
export const DEPLOYMENT_ID_COOKIE_NAME = '__vdpl'
